import React from 'react';
import { useSpc } from '../context/SpcContext';
import { Logo, motion } from './ui';

const LABELS = { view: "Who's Racing?", form: 'Add My Race', map: 'Race Map' };

export default function RaceHub() {
  const { raceHub, closeRaceHub, setRaceHubMode, SPC_LINKS } = useSpc();
  const url = raceHub.mode === 'form' ? SPC_LINKS.raceForm : raceHub.mode === 'map' ? SPC_LINKS.raceMap : SPC_LINKS.raceView;

  return (
    <div className={`racehub-overlay ${raceHub.open ? 'open' : ''}`} aria-hidden={!raceHub.open}>
      <div className="racehub-top">
        <div className="racehub-brand">
          <Logo size={40} />
          <div><strong>SPC Race Hub</strong><small>{LABELS[raceHub.mode] || LABELS.view}</small></div>
        </div>
        <button className="racehub-close" data-testid="racehub-close-btn" onClick={closeRaceHub} aria-label="Close Race Hub">×</button>
      </div>
      <div className="racehub-tabs">
        {['view', 'form', 'map'].map(m => (
          <button key={m} data-testid={`racehub-tab-${m}`} className={`racehub-tab ${raceHub.mode === m ? 'active' : ''}`} onClick={() => setRaceHubMode(m)}>{LABELS[m]}</button>
        ))}
      </div>
      <div className="racehub-frame-wrap">
        {raceHub.open && <iframe className="racehub-frame" title="SPC Race Hub" src={url} />}
        <button className="racehub-fallback" onClick={() => window.open(url, '_blank', 'noopener')}>Open externally ↗</button>
      </div>
      <div className="racehub-note">Race Hub stays inside the SPC app. In production these screens render natively from the Race Hub data.</div>
    </div>
  );
}
